export const columns: any[] = [
	{
		title: '问卷编号',
		dataIndex: 'order',
		align: 'center',
		width: 100,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '问卷名称',
		align: 'center',
		dataIndex: 'name',
	},
	{
		title: '描述',
		align: 'center',
		dataIndex: 'templateDesc',
	},
	{
		title: '状态',
		align: 'center',
		dataIndex: 'status',
		scopedSlots: { customRender: 'status' },
	},
	{
		title: '应用机构',
		align: 'center',
		dataIndex: 'companyList',
		scopedSlots: { customRender: 'companyList' },
	},
	{
		title: '更新人',
		align: 'center',
		dataIndex: 'updatorName',
	},
	{
		title: '更新时间',
		align: 'center',
		dataIndex: 'updateTime',
		scopedSlots: { customRender: 'updateTime' },
	},
	{
		title: '操作',
		align: 'center',
		dataIndex: 'status',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
